import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Businesses({ children }) {
  return (
    <div>
      <CustomPageHeader icon='building' text='Businesses' />
      { children }
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/Business/index.js